import React from 'react';
import { useTranslation } from 'react-i18next';
import { BuPlayList, CompanyDescription, FooterLinks, PlayBelonging, SrgPlaySection, SRGSSRImage, StyledFooter } from './Footer.styles';
import { svgBasePath } from '../../../../play-core/utils/base-path';
import { useAnalyticsDispatch } from '../../analytics/AnalyticsContext';
import { useFeedbackUrl } from '../../config/use-feedback-url';
import { useVideoConfig } from '../../config/VideoAppContext';
import { useDataDispatch } from '../../providers/DataProvider/DataContext';
import { renderEntries } from '../../utils/list-entries-render-helper';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Footer = ({
  config
}) => {
  const feedbackUrl = useFeedbackUrl();
  const {
    t
  } = useTranslation();
  const dispatch = useDataDispatch();
  const analytics = useAnalyticsDispatch();
  const {
    privacyBanner
  } = useVideoConfig();
  const {
    buPlayLinks,
    internalLinks = [],
    externalLinks = [],
    privacyLink,
    privacySettings
  } = config;
  const additionalLinks = feedbackUrl ? [{
    title: t('global.participateFeedback'),
    url: feedbackUrl,
    type: 'Link'
  }] : [];
  let links = [...internalLinks, ...externalLinks, ...additionalLinks, privacyLink];
  if (privacyBanner.isEnabled) {
    links = [...links, privacySettings];
  }
  return /*#__PURE__*/_jsxs(StyledFooter, {
    children: [links.length > 0 && /*#__PURE__*/_jsx(FooterLinks, {
      children: renderEntries(links, analytics, dispatch)
    }), /*#__PURE__*/_jsxs(SrgPlaySection, {
      children: [/*#__PURE__*/_jsxs(PlayBelonging, {
        href: config.srgssrUrl,
        children: [/*#__PURE__*/_jsx(SRGSSRImage, {
          alt: 'SRG SSR',
          src: `${svgBasePath}/srgssr.svg`
        }), /*#__PURE__*/_jsx(CompanyDescription, {
          children: t('global.srgAboutDescription')
        })]
      }), /*#__PURE__*/_jsx(BuPlayList, {
        children: renderEntries(buPlayLinks, analytics, dispatch)
      })]
    })]
  });
};